import React, { useState, useEffect, lazy, Suspense } from 'react';
import Box from '@mui/material/Box';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams  } from 'react-router-dom';
import Typography from '@mui/material/Typography'; 
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardActions from '@mui/material/CardActions';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import ImageUploading from "react-images-uploading";
import { PlayerInfoValidation } from '../../assets/validation/validation';
import { playerInfoAction } from '../../redux/actions/playerInfoAction';
import CircularProgress from '@mui/material/CircularProgress';
import config from '../../configs';
import FormHelperText from '@mui/material/FormHelperText';
import { Loader } from "../../errorPages/Loader";


export default function PlayerInfoEdit() {
    const [statuss, setStatuss] = useState(true);
    const [images, setImages] = React.useState([]);
    const [orginalImages, setOrignalImages] = React.useState([]);
    const [data, setData] = React.useState([]);
    const [imageError, setImageError] = React.useState("");
    const [imageLoader, setImageLoader] = React.useState(true);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const maxNumber = 1;
    const onChange = (imageList, addUpdateIndex) => {
      // data for submit
      setImages(imageList);
      if(imageList.length > 0) {
        setImageError("");
      }
    };

    const onErrorChange = (errors, files) => {
        if(errors){
            setImages([]);
            
        }
    };
  
    const handleStatusChange = (event) => {
        setStatuss(event.target.value);
    };

    useEffect(() => { 
        dispatch(playerInfoAction.getSingleItem(id)); 
           // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);
    
    const {singlePlayer , singlePlayerStatus , loading } = useSelector(state => state.playerInfo);   

    useEffect(() => { 
        if(singlePlayerStatus === true){
            setData(singlePlayer);
        }
    }, [singlePlayerStatus, singlePlayer])


    useEffect(() => { 
        setImageLoader(true);
        if(data && data!==undefined && data !== ""){
            if(data.status !== undefined ){
                setStatuss(data.status);
            }

            if(data?.headshot && data?.headshot?.original){
                setOrignalImages(data?.headshot?.original);
            }


            if((data?.headshot && data?.headshot?.alter_original)){
                let arrValue = [];
                let arrObject = {
                    path: data?.headshot?.alter_original
                }   
                arrValue.push(arrObject)
                setImages(arrValue);                    
            }else {
                setImages([]);            
            }
        }

        const timeoutId = setTimeout(() => {
            setImageLoader(false);
        }, 500);

        return () => {
            clearTimeout(timeoutId);
        };

    }, [data])

  return (
    <Box sx={{ mb:3 }} className='cardWrapper'>
        {loading ? <Loader/> : '' }
         <div className="pageTitleWrap">
            <Stack  direction="row" spacing={1}   alignItems="center">
                <Typography type="submit" variant="text" component={Link} to={"/player-info"} > Player Info List</Typography>
                <Typography className="" component={"h2"} variant="h2" >
                    / Edit Player
                </Typography>
            </Stack>
        </div>
        <Formik
            initialValues={{
                firstName : data?.first_name || '',
                lastName : data?.last_name || '',
                shirtNumber : data?.jersey_number || '',
                altFirstName: data?.alter_first_name || '',
                altLastName: data?.alter_last_name || '',
                altShirtNumber: data?.alter_jersey_number || '',
            }}
            validationSchema={PlayerInfoValidation}
            enableReinitialize
            onSubmit={(values, {setErrors, setSubmitting}) => {
                console.log(values, "values");
                let form_data = new FormData();
                form_data.append('alter_first_name', values.altFirstName);
                form_data.append('alter_last_name', values.altLastName);
                form_data.append('alter_jersey_number', values.altShirtNumber);
                form_data.append('status', statuss);
                if(images && images.length > 0){
                    images.map((field, idx) => {
                        if(field.file){
                            form_data.append('file', field.file);
                        } else {
                             form_data.append('alter_original', field.path);
                        }
                        return true;
                    });
                }else {
                    form_data.append('alter_original',  '');
                }
                
               dispatch(playerInfoAction.update(id, form_data, setErrors, setSubmitting, navigate));
            }}>
            {({ errors, touched, values, handleChange, handleBlur, handleSubmit, handleReset, isSubmitting, setFieldValue }) => (
            <form onSubmit={handleSubmit}> 
                <Card sx={{}} variant="outlined" className="formWrapper">
                    <CardHeader title="Edit"/>
                    <CardContent > 
                        <Grid container spacing={2} alignItems="stretch">
                            <Grid item lg={6} xl={6} sx={{ pr:3}}>
                                <Grid container spacing={2} alignItems="stretch">
                                    <Grid item lg={6} xl={6} sx={{pr:3}}>
                                        <TextField
                                            error={errors.firstName && touched.firstName}
                                            label="First Name"
                                            fullWidth 
                                            name="firstName"
                                            value={values.firstName}
                                            disabled
                                            onChange={handleChange}
                                            onBlur={(e) => {
                                                const val = (e.target.value || '').replace(/\s+/gi, ' ');
                                                setFieldValue(e.target.name, val.trim());
                                                handleBlur(e);
                                            }}
                                            helperText={(errors.firstName && touched.firstName) && errors.firstName}
                                            margin="normal"
                                            variant="outlined"
                                            sx={{
                                                mb:3,
                                                '.Mui-disabled': {
                                                    "-webkit-text-fill-color":"#000",
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item lg={6} xl={6}>
                                        <TextField
                                            error={errors.lastName && touched.lastName}
                                            label="Last Name"
                                            fullWidth 
                                            name="lastName"
                                            value={values.lastName}
                                            onChange={handleChange}
                                            disabled
                                              onBlur={(e) => {
                                                const val = (e.target.value || '').replace(/\s+/gi, ' ');
                                                setFieldValue(e.target.name, val.trim());
                                                handleBlur(e);
                                            }}
                                            helperText={(errors.lastName && touched.lastName) && errors.lastName}
                                            margin="normal"
                                            sx={{
                                                mb:3,
                                                '.Mui-disabled': {
                                                    "-webkit-text-fill-color":"#000",
                                                }
                                            }}
                                            variant="outlined"
                                            // required={false}
                                            // InputLabelProps={{ required: true }} 
                                        />
                                    </Grid>
                                </Grid>
                                <div className="upload__image-wrapper">
                                    <Card sx={{height:"95%", border:"1px solid rgba(20,20,20,0.2)", minHeight:"250px", maxHeight:"250px", display:"flex", justifyContent:"center", alignItems:"center"}} elevation={0}>
                                        <Suspense fallback={<div>Loading...</div>}>
                                            {imageLoader ? (
                                                <CircularProgress size={20}/> 
                                            ) : <CardMedia
                                                    component="img"
                                                    height="250"
                                                    image={orginalImages}
                                                    alt="green iguana"
                                                    sx={{ objectFit: "contain" }}
                                                />  }
                                        </Suspense>
                                    </Card>

                                    <Stack className='upload__helpText' direction="row" spacing={2} justifyContent="space-between"  alignItems="center">
                                        <Typography  variant="body1" component="p" 
                                        sx={{
                                            minHeight:"14px"
                                        }}
                                        ></Typography>
                                    </Stack>
                                </div>
                                <TextField
                                    error={errors.shirtNumber && touched.shirtNumber}
                                    label="Shirt Number"
                                    fullWidth 
                                    name="shirtNumber"
                                    disabled
                                    value={values.shirtNumber}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    helperText={(errors.shirtNumber && touched.shirtNumber) && errors.shirtNumber}
                                    margin="normal"
                                    variant="outlined"
                                    sx={{
                                        mb:3,
                                        '.Mui-disabled': {
                                            "-webkit-text-fill-color":"#000",
                                        }
                                    }}
                                />
                                <FormControl sx={{mt:2, width:"100%", textAlign:"left"}}>
                                    <FormLabel id="demo-row-radio-buttons-group-label">Status </FormLabel>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="status"
                                        value={statuss}
                                        onChange={handleStatusChange}
                                    >
                                        <FormControlLabel value={true} control={<Radio />} label="Active" />
                                        <FormControlLabel value={false} control={<Radio />} label="Inactive" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item lg={6} xl={6} sx={{ pl:3}}>
                                <Grid container spacing={2} alignItems="stretch">
                                    <Grid item lg={6} xl={6} sx={{pr:3}}>
                                        <TextField
                                            error={errors.altFirstName && touched.altFirstName}
                                            label="Alternate First Name"
                                            fullWidth 
                                            name="altFirstName"
                                            value={values.altFirstName}
                                            onChange={handleChange}
                                            onBlur={(e) => {
                                                const val = (e.target.value || '').replace(/\s+/gi, ' ');
                                                setFieldValue(e.target.name, val.trim());
                                                handleBlur(e);
                                            }}
                                            helperText={(errors.altFirstName && touched.altFirstName) && errors.altFirstName}
                                            margin="normal"
                                            sx={{mb:3}}
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item lg={6} xl={6}>
                                        <TextField
                                            error={errors.altLastName && touched.altLastName}
                                            label="Alternate Last Name"
                                            fullWidth 
                                            name="altLastName"
                                            value={values.altLastName}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            helperText={(errors.altLastName && touched.altLastName) && errors.altLastName}
                                            margin="normal"
                                            sx={{mb:3}}
                                            variant="outlined"
                                        />
                                    </Grid>
                                </Grid>
                                <ImageUploading
                                    value={images}
                                    onChange={onChange}
                                    onError={onErrorChange}
                                    maxFileSize={5242880}
                                    maxNumber={maxNumber}
                                    dataURLKey="data_url"
                                    acceptType={["jpg","bmp","png"]}
                                    resolutionType="ratio"	
                                    resolutionWidth={600}
                                    resolutionHeight={600}
                                >
                                    {({
                                    imageList,
                                    onImageUpload,
                                    onImageRemoveAll,
                                    onImageUpdate,
                                    onImageRemove,
                                    isDragging,
                                    dragProps,
                                    errors 
                                    }) => (
                                    // write your building UI
                                    
                                    <div className="upload__image-wrapper">
                                        <Card sx={{height:"95%", border:"1px solid rgba(20,20,20,0.2)", minHeight:"250px", maxHeight:"250px", display:"flex", justifyContent:"center", alignItems:"center"}} elevation={0}>
                                        {images && images.length > 0 ?
                                            images.map((image, index) => {
                                                return(
                                                    <div key={index} className="image-item">
                                                    {imageLoader ? (
                                                        <CircularProgress size={20}/> 
                                                    ) : (
                                                        <>
                                                            <CardMedia
                                                                component="img"
                                                                height="250"
                                                                image={image.path ? config.apiBaseUrl+'/'+image.path : image.data_url}
                                                                alt="green iguana"
                                                                onClick={() => onImageUpdate(index)}
                                                                sx={{ objectFit: "contain" }}
                                                            />
                                                            <div className="image-item__btn-wrapper">
                                                                {/* <Button type="button" variant='contained' color="secondary" >Update</Button> */}
                                                                <IconButton className='delete_icon'  onClick={() => onImageRemove(index)}>
                                                                    <i className='icon-close'></i>
                                                                </IconButton>
                                                            </div>
                                                        </>
                                                    )}
                                                    </div>
                                                )
                                            })
                                            :
                                            <CardContent sx={{p:"0 !important", height:"100%"}}>
                                                <Box 
                                        
                                                onClick={onImageUpload}
                                                {...dragProps}
                                                >
                                                    <span className='upload_icon user'><i className='icon-user'></i></span>
                                                    {/* <span className='upload_content'>Upload Image</span> */}
                                                </Box>
                                            </CardContent>
                                            
                                            }
                                        </Card>
                                        {errors ?
                                            <FormHelperText error={true}>
                                                {errors.acceptType && <span>Selected file type is not allow</span>}
                                                {errors.maxFileSize && <span>Product Image's size cannot exceed 5 MB</span>}
                                                {errors.resolution && <span>Selected file is not matching desired resolution</span>}
                                            </FormHelperText >
                                        : <FormHelperText error={true}>{imageError}</FormHelperText>
                                        }
                                        <Stack className='upload__helpText' direction="row" spacing={2} justifyContent="space-between"  alignItems="center">
                                            <Typography  variant="body1" component="p">
                                                File Size: Max 5 Mb
                                            </Typography>
                                            {/* <Typography  variant="body1" component="p">
                                                File Resolution: above <b>600 x 600</b> or <b>1:1</b> aspect ratio
                                            </Typography> */}
                                            <Typography  variant="body1" component="p">
                                                File Format: .jpeg .jpg .png .bmp 
                                            </Typography>
                                        </Stack>
                                    </div>
                                    )}
                                </ImageUploading>
                                <TextField
                                    error={errors.altShirtNumber && touched.altShirtNumber}
                                    label="Alternate Shirt Number"
                                    fullWidth 
                                    name="altShirtNumber"
                                    value={values.altShirtNumber}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    helperText={(errors.altShirtNumber && touched.altShirtNumber) && errors.altShirtNumber}
                                    margin="normal"
                                    variant="outlined"
                                />
                            </Grid>
                        </Grid> 
                    </CardContent>
                    <CardActions sx={{justifyContent:"center"}}>
                        <Button type="submit" variant="contained" color="primary"
                          disabled ={isSubmitting} 
                        > {isSubmitting ? <CircularProgress size={20}/> :  "Submit"}</Button> 
                        <Button type="button" variant="contained" color="secondary"
                        onClick={(e) => {    
                            handleReset();
                            navigate(-1);
                        }}
                        >Cancel</Button>
                    </CardActions>
                </Card>  
            </form>
            )}
        </Formik>    
    </Box>
  )
}
